module.exports = __webpack_public_path__ + "static/media/search-8.0648d7be.png";